import { Animated, Platform, Easing } from 'react-native';
export const getPostion = (position) => {
    switch (position) {
        case 'top-left':
            return { justifyContent: 'flex-start', alignItems: 'flex-start' };
        case 'top':
            return { justifyContent: 'center', alignItems: 'flex-start' };
        case 'top-right':
            return { justifyContent: 'flex-end', alignItems: 'flex-start' };
        case 'left':
            return { justifyContent: 'flex-start', alignItems: 'center' };
        case 'center':
            return { justifyContent: 'center', alignItems: 'center' };
        case 'right':
            return { justifyContent: 'flex-end', alignItems: 'center' };
        case 'bottom-left':
            return { justifyContent: 'flex-start', alignItems: 'flex-end' };
        case 'bottom':
            return { justifyContent: 'center', alignItems: 'flex-end' };
        case 'bottom-right':
            return { justifyContent: 'flex-end', alignItems: 'flex-end' };
    }
};
export const animatedTo = (argus) => {
    var _a, _b;
    const { target, toValue, duration, fn } = argus;
    (_b = (_a = Animated.timing(target, {
        toValue,
        duration,
        useNativeDriver: Platform.OS !== 'web',
        easing: Easing.in(Easing.linear),
    })) === null || _a === void 0 ? void 0 : _a.start) === null || _b === void 0 ? void 0 : _b.call(_a, ({ finished }) => {
        if (finished) {
            fn && fn();
        }
    });
};
